var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncorrect3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.304 15.143v9.201c0 .643-.522 1.164-1.166 1.164h-1.976a.116.116 0 01-.116-.116V16.19c0-.643.522-1.164 1.166-1.164h1.975c.064 0 .117.052.117.116z",
    fill: "url(#incorrect_3_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.814 1.163v10.77a.116.116 0 01-.117.116H6.71a1.165 1.165 0 01-1.166-1.164V.116c0-.064.052-.116.117-.116h1.987c.644 0 1.166.52 1.166 1.163z",
    fill: "url(#incorrect_3_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.814 20.55v8.278c0 .643-.522 1.163-1.166 1.163H5.66a.116.116 0 01-.117-.116v-8.277c0-.643.522-1.164 1.166-1.164h1.987c.065 0 .117.052.117.116z",
    fill: "url(#incorrect_3_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26 23.398v5.43c0 .643-.521 1.164-1.165 1.164H.117A.116.116 0 010 29.875v-5.43c0-.643.522-1.164 1.166-1.164h1.978c.065 0 .116.053.116.117z",
    fill: "url(#incorrect_3_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.304 5.607v4.717a.116.116 0 01-.117.117h-1.975c-.644 0-1.166-.521-1.166-1.164V4.56c0-.064.052-.117.117-.117h1.975c.643 0 1.166.521 1.166 1.164z",
    fill: "url(#incorrect_3_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26 1.163v5.432a.116.116 0 01-.116.116H1.166C.522 6.71 0 6.19 0 5.548V.116C0 .052.052 0 .117 0h1.978C2.739 0 3.26.52 3.26 1.163z",
    fill: "url(#incorrect_3_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29.88v-7.734c0-.74-.295-1.45-.82-1.974l-2.858-2.852a2.801 2.801 0 00-1.978-.818h-7.75a.117.117 0 00-.117.116v7.734c0 .74.295 1.45.82 1.974l2.858 2.852a2.8 2.8 0 001.978.818h7.75A.117.117 0 0030 29.88z",
    fill: "url(#incorrect_3_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 .116V7.85c0 .74-.295 1.45-.82 1.974l-2.858 2.852a2.801 2.801 0 01-1.978.818h-7.75a.117.117 0 01-.117-.116V5.644c0-.74.295-1.45.82-1.974L20.155.818A2.8 2.8 0 0122.133 0h7.75c.065 0 .117.052.117.116z",
    fill: "url(#incorrect_3_svg__paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.888 18.496h-9.493v3.722h9.493v-3.722z",
    fill: "url(#incorrect_3_svg__paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.42.901v3.722h-7.935c-.517 0-1.032.021-1.544.105-1.458.321-2.51 1.733-2.62 3.2-.042.77-.035 1.542-.032 2.31h-.005v1.815h10.047v3.721h-10.042c.007 4.742.002 9.48.002 14.22h-3.816c.006-4.628 0-9.257.006-13.888v-4.647c.05-1.677-.145-3.382.152-5.044.424-2.24 2.046-4.203 4.168-5.001.985-.405 2.022-.5 3.07-.511.085-.002.167-.002.253-.002h8.296z",
    fill: "url(#incorrect_3_svg__paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.619 1.25c-.006 1.124-.006 2.248.001 3.373h-2.066c-.519 0-1.037.021-1.55.105-1.458.321-2.51 1.733-2.62 3.2-.04.77-.034 1.542-.03 2.31h-.006v1.815h6.27v3.721h-6.265c.007 4.742.002 9.48.002 14.22H85.54c.006-4.628 0-9.256.006-13.888v-4.647c.05-1.677-.146-3.382.15-5.044.425-2.24 2.048-4.203 4.168-5.001C90.93.978 92.056.901 93.19.901h2.43v.015l-.001.335z",
    fill: "url(#incorrect_3_svg__paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.132 29.645v.35h-2.429c-1.134 0-2.261-.077-3.327-.514-2.12-.798-3.743-2.76-4.167-5-.297-1.662-.101-3.367-.151-5.045V14.79c-.006-4.632 0-9.26-.006-13.889h3.816l.002 10.106v1.047h6.262v3.722h-6.262v3.067h-.009v1.815h.005c-.003.768-.01 1.54.03 2.31.111 1.466 1.163 2.878 2.62 3.2a9.68 9.68 0 001.551.105h2.066c-.007 1.124-.007 2.249-.001 3.372z",
    fill: "url(#incorrect_3_svg__paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.111 29.994h-4.987l-.292-.552-1.087-2.073c-.377-.737-.768-1.473-1.158-2.206-1.095-2.045-2.204-4.078-3.041-6.22a25.282 25.282 0 01-.538-1.516l-.183-.587-.182.587a25.482 25.482 0 01-.538 1.515c-.837 2.143-1.946 4.176-3.041 6.221-.39.733-.781 1.47-1.159 2.206l-1.087 2.073-.292.552h-4.986l4.714-8.261 1.247-2.177v-.002c.12-.21.241-.424.36-.64l.057-.1.981-1.715.144-.254a3.585 3.585 0 00-.03-3.337l-1.341-2.359-2.902-5.102-1.027-1.797-1.595-2.8-.314-.55h4.92l.298.55 1.569 2.859.559 1.016c.739 1.372 1.465 2.759 2.23 4.13.311.568.593 1.152.855 1.744.132.293.256.59.379.887l.181.445.181-.445c.123-.298.248-.594.38-.887.262-.592.543-1.176.855-1.744.765-1.371 1.491-2.758 2.229-4.13l.56-1.016 1.568-2.86.299-.55h4.92l-.314.55-1.595 2.801-1.027 1.797-2.902 5.102-1.342 2.36a3.595 3.595 0 00-.029 3.336l.144.254.981 1.716.056.099c.12.216.241.43.361.64v.002l1.247 2.177 4.714 8.261z",
    fill: "url(#incorrect_3_svg__paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.564 5.428c2.886-.495 6.03-.331 8.636 1.128 2.085 1.16 3.467 3.317 4.056 5.607.61 2.242.567 4.584.529 6.886-.08 2.813-.768 5.782-2.7 7.907-1.924 2.128-4.85 3.055-7.646 3.038-2.785.076-5.794-.581-7.818-2.64-2.005-1.996-2.745-4.91-2.899-7.67-.106-3.29-.168-6.793 1.457-9.765 1.26-2.425 3.74-4.035 6.385-4.49zm1.084 3.017c-1.397.239-2.715 1.005-3.51 2.205-1.165 1.764-1.425 3.95-1.445 6.023-.013 2.022-.057 4.098.591 6.041.45 1.433 1.365 2.782 2.736 3.449 1.705.806 3.71.869 5.507.361 1.512-.43 2.75-1.605 3.361-3.053 1.006-2.337.868-4.949.845-7.44-.084-2.18-.465-4.58-2.086-6.168-1.563-1.54-3.943-1.756-6-1.418z",
    fill: "url(#incorrect_3_svg__paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.385 25.294c-.582 1.718-1.997 3.04-3.623 3.748-2.184.98-4.656 1.124-7.003.805-2.108-.304-4.24-1.209-5.605-2.922-.645-.792-1.056-1.741-1.312-2.729l-.1-.422-.153-.644h3.736c.45 1.793 2.119 2.977 3.856 3.3 1.902.354 4.052.238 5.677-.93.98-.678 1.535-1.99 1.129-3.149-.408-1.192-1.571-1.875-2.674-2.3-2.22-.834-4.491-1.532-6.704-2.39-1.725-.696-3.386-1.952-3.94-3.821-.591-2.063-.23-4.476 1.225-6.095 1.333-1.496 3.315-2.216 5.25-2.468 2.533-.282 5.275-.035 7.443 1.428 1.294.86 2.217 2.21 2.63 3.71l.104.422.163.657h-3.742c-.435-1.358-1.639-2.308-2.98-2.654-1.793-.472-3.857-.43-5.452.615-.959.618-1.49 1.872-1.116 2.982.313.99 1.256 1.58 2.163 1.942 1.971.73 3.958 1.41 5.932 2.136 1.605.591 3.194 1.438 4.267 2.817 1.3 1.658 1.487 4.001.829 5.962z",
    fill: "url(#incorrect_3_svg__paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint0_linear",
    x1: 14.304,
    y1: 15.027,
    x2: 8.362,
    y2: 16.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint1_linear",
    x1: 8.814,
    y1: 0,
    x2: 2.723,
    y2: 1.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint2_linear",
    x1: 8.814,
    y1: 20.434,
    x2: 2.959,
    y2: 22.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint3_linear",
    x1: 3.26,
    y1: 23.281,
    x2: -2.015,
    y2: 25.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint4_linear",
    x1: 14.304,
    y1: 4.443,
    x2: 9.273,
    y2: 7.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint5_linear",
    x1: 3.26,
    y1: 0,
    x2: -2.015,
    y2: 2.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint6_linear",
    x1: 30,
    y1: 16.502,
    x2: 16.506,
    y2: 30.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint7_linear",
    x1: 30,
    y1: 0,
    x2: 16.506,
    y2: 13.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint8_linear",
    x1: 123.888,
    y1: 18.496,
    x2: 121.359,
    y2: 24.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint9_linear",
    x1: 144.42,
    y1: 0.901,
    x2: 119.887,
    y2: 14.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint10_linear",
    x1: 95.621,
    y1: 0.901,
    x2: 77.603,
    y2: 7.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint11_linear",
    x1: 110.133,
    y1: 0.901,
    x2: 92.115,
    y2: 7.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint12_linear",
    x1: 171.111,
    y1: 0.899,
    x2: 142.929,
    y2: 22.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint13_linear",
    x1: 80.804,
    y1: 5.176,
    x2: 56.3,
    y2: 26.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incorrect_3_svg__paint14_linear",
    x1: 55.755,
    y1: 5.175,
    x2: 32.093,
    y2: 22.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })))));
}

export default SvgIncorrect3;